import { useState  } from 'react';
import { Outlet} from 'react-router-dom';
import Navbar from './Navbar';

const Layout = ({ Auth }) => {
    const [selectedNomina, setSelectedNomina] = useState(null);
      const [empleadoSeleccionado, setEmpleadoSeleccionado] = useState(null); // nuevo
  return (
    <div className="layout-container">
  <div className="navbar">
    <Navbar Auth={Auth}
    selectedNomina={selectedNomina}
    setSelectedNomina={setSelectedNomina} />
  </div>
  <div className="main-content">
    <Outlet context={{selectedNomina, empleadoSeleccionado, setEmpleadoSeleccionado }} />
  </div>
</div>
  );
};

export default Layout;
